'use client';

import { Crown, Shield, ShieldCheck } from 'lucide-react';
import type { GroupRole } from '@/lib/groups/authority';
import { cn } from '@/lib/utils';

// Four distinct, rankable role treatments (Owner > Admin > Mod > Member).
// All colors come from theme tokens — no hardcoded hex, no per-theme branches.
export default function RoleBadge({
  role,
  className,
}: {
  role: GroupRole;
  className?: string;
}) {
  if (role === 'owner') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 h-[20px] px-1.5 rounded-sm text-[10px] font-medium uppercase tracking-wider',
          'bg-accent-soft text-accent border border-accent',
          className,
        )}
      >
        <Crown className="w-3 h-3" strokeWidth={2} />
        Owner
      </span>
    );
  }
  if (role === 'admin') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 h-[20px] px-1.5 rounded-sm text-[10px] font-medium uppercase tracking-wider',
          'bg-pill-active-bg text-pill-active-text',
          className,
        )}
      >
        <ShieldCheck className="w-3 h-3" strokeWidth={2} />
        Admin
      </span>
    );
  }
  if (role === 'moderator') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 h-[20px] px-1.5 rounded-sm text-[10px] font-medium uppercase tracking-wider',
          'border border-border-strong text-text-secondary',
          className,
        )}
      >
        <Shield className="w-3 h-3" strokeWidth={2} />
        Mod
      </span>
    );
  }
  // Member — quiet bordered label.
  return (
    <span
      className={cn(
        'inline-flex items-center h-[20px] px-1.5 rounded-sm text-[10px] font-medium uppercase tracking-wider',
        'border border-border-subtle text-text-tertiary',
        className,
      )}
    >
      Member
    </span>
  );
}
